/* eslint-disable no-underscore-dangle */
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Validations } from '../..';
import { TimePickerMatcher } from './validators/time-picker-validator-directive';

@Component({
    selector: 'formly-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.less'],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
    ],
})
export class FormlyTimePickerComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	matcher = new TimePickerMatcher();

	public ngOnInit(): void {
		this.setValidators();
	}

	setValidators(): void {
		if (this.props.required === true) {
			this.formControl.addValidators([Validators.required]);
		}
	}

	public getErrorMessage(): string {
		if (this.formControl.errors?.required) {
			return Validations.requiredValidationMessage({}, this.field);
		}

		if (this.formControl.errors?.invalidTimeRange) {
			if (this.props.isStartTime) {
				return Validations.maxTimeValidationMessage({}, this.field);
			}

			if (this.props.isEndTime) {
				return Validations.minTimeValidationMessage({}, this.field);
			}

			return 'Invalid Time Range';
		}

		return '';
	}
}
